export const FIREBASE_STORAGE_IMAGE_PATH = "images/";
export const IMAGE_COMPRESSION_QUALITY = 0.7;